import React, { useState, useEffect } from "react";
import { Fragment } from "react";
import {
  Button,
  Row,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { authCustomerHeader } from "../../functions/CoreFunctions";
import API from "../../redux/actions/API";
import { CustomAlertMessage } from "../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import { useNavigate, Link, useParams } from "react-router-dom";
import { AGENCY_IDLOGO_URL, USER_CREATE_URL } from "../../constants/ApiPaths";
import CustomButtonLoader from "../CustomComponents/CustomButtonLoader";
import Iconawesomeeye from "../../images/Iconawesomeeye.svg";
import Iconionicmdeyeoff from "../../images/Iconionicmdeyeoff.svg";
import CustomPageLoading from "../CustomComponents/CustomPageLoading";
import { USER_SIGNIN } from "../../constants/RoutePaths";
import HeaderLogo from "../common/HeaderLogo";
import { LandingPagePlansBlock } from "./UserSignin";
import { TTID } from "../../constants/LocalStorageVariables";

export default function UserSignUp(props) {
  const [passwordShown, setPasswordShown] = useState(false);
  // if (props.location.state) {
  //   let { agencyUrl } = props.location.state;
  // let  logagencyUrl = agencyUrl;
  // }
  const togglePassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const [agencyPlans, setAgencyPlans] = useState([]);
  const [pageloading, setPageLoading] = useState(true);
  const history = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  let { agencyUrl } = useParams();
  // validation schema
  Yup.addMethod(Yup.string, "phoneNumberValidation", function (errorMessage) {
    return this.test(`test-card-type`, errorMessage, function (value) {
      const { path, createError } = this;
      if (value) {
        let v1 = value;
        if (value.includes("+1 ")) {
          v1 = value.split("+1 ")[1];
        } else {
          // Handle the case where "+1 " is not present
          v1 = value;
        }

        var num = v1.replace(/\D+/g, "");
        var check = v1.match(/[A-Za-z_@./#&+!^*+=,:;]/) ? false : true;
        let Pass = num.length <= 10;
        return (check && Pass) || createError({ path, message: errorMessage });
      } else {
        return createError({ path, message: "Phone Number is Required" });
      }
    });
  });
  const validationSchema = Yup.object({
    firstName: Yup.string().trim().required("First Name is required"),
    lastName: Yup.string().trim().required("Last Name is required"),
    email: Yup.string().trim().required("Email is required"),
    phoneNumber: Yup.string().phoneNumberValidation("Invalid Phone Number"),
    password: Yup.string().trim().required(" Password Required"),
  });
  const saveFormValues = async (values) => {
    setLoading(true);
    const config = {
      method: "POST",
      url: USER_CREATE_URL,
      data: {
        ...values,
        stateId: null,
        agencyUrl: agencyUrl,
        hyperLink: `${window.location.host}/customer/${agencyUrl}`,
      },
      headers: authCustomerHeader(),
    };

    try {
      const response = await API(config);
      const { status } = response.data;

      if (status === "Success") {
        resetForm({});

        CustomAlertMessage(
          "Account Created successfully!",
          "success",
          enqueueSnackbar
        );
        history(`${USER_SIGNIN}/${agencyUrl}`);
      }
    } catch (error) {
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };

  //Formik
  const { handleSubmit, handleChange, resetForm, values, errors, touched } =
    useFormik({
      initialValues: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        gender: "",
        dateOfBirth: "",
        phoneNumber: "",
        profileImage: "",
        stateId: "",
        city: "",
        address: "",
        zip: "",
        agencyUrl: "",
      },
      validationSchema,
      onSubmit: (values) => saveFormValues(values),
    });

  useEffect(() => {
    const getAgencyIdandLogo = async () => {
      const config = {
        method: "GET",
        url: AGENCY_IDLOGO_URL,
        headers: authCustomerHeader(),
        params: { agencyUrl: agencyUrl },
      };
      try {
        const response = await API(config);
        const { status, data, agencyId, agencyLogo, ttid } = response.data;
        localStorage.setItem("LOGGED_AGENCY_ID", agencyId);
        localStorage.setItem("AGENCYLOGO", agencyLogo);
        localStorage.setItem(TTID, ttid);

        if (status === "Success") {
          setAgencyPlans(data);
        } else if (status === "Error") {
        }
      } catch (error) {
        console.error(error);
      } finally {
        setPageLoading(false);
      }
    };
    getAgencyIdandLogo();
  }, [agencyUrl]);

  if (pageloading) {
    return <CustomPageLoading />;
  }
  return (
    <Fragment>
      <div>
        <HeaderLogo agencyUrl={agencyUrl} userIndex="userIndex" />
        <div className="urs-bg">
          <div className="urs-overlay"></div>
          <Container fluid>
            <Row className="align-items-center">
              <LandingPagePlansBlock agencyPlans={agencyPlans} />
              <Col lg="12" xl="4">
                <div className="urs-form">
                  <h4>Create Your Account</h4>

                  <Form form="true" onSubmit={handleSubmit}>
                    <FormGroup>
                      <Label for="firstName">First Name</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          name="firstName"
                          id="firstName"
                          value={values.firstName}
                          placeholder="Enter First Name"
                          invalid={
                            errors.firstName && touched.firstName ? true : false
                          }
                          onChange={handleChange}
                        />
                        <FormFeedback>
                          {errors.firstName && touched.firstName
                            ? errors.firstName
                            : ""}
                        </FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <Label for="lastName">Last Name</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          name="lastName"
                          id="lastName"
                          value={values.lastName}
                          placeholder="Enter Last Name"
                          invalid={
                            errors.lastName && touched.lastName ? true : false
                          }
                          onChange={handleChange}
                        />
                        <FormFeedback>
                          {errors.lastName && touched.lastName
                            ? errors.lastName
                            : ""}
                        </FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          name="email"
                          id="email"
                          value={values.email}
                          placeholder="Enter Email"
                          invalid={errors.email && touched.email ? true : false}
                          onChange={handleChange}
                        />
                        <FormFeedback>
                          {errors.email && touched.email ? errors.email : ""}
                        </FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <Label for="password"> Password</Label>
                      <InputGroup>
                        <Input
                          type={passwordShown ? "text" : "password"}
                          name="password"
                          id="password"
                          value={values.password}
                          placeholder="Enter  Password"
                          invalid={
                            errors.password && touched.password ? true : false
                          }
                          onChange={handleChange}
                        />
                        <>
                          <InputGroupText
                            onClick={togglePassword}
                            style={{ cursor: "pointer" }}
                          >
                            {passwordShown ? (
                              <img src={Iconawesomeeye} alt="" />
                            ) : (
                              <img src={Iconionicmdeyeoff} alt="" />
                            )}
                          </InputGroupText>
                        </>
                        <FormFeedback>
                          {errors.password && touched.password
                            ? errors.password
                            : ""}
                        </FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    <FormGroup>
                      <Label for="phoneNumber">Phone Number</Label>
                      <InputGroup>
                        <Input
                          type="text"
                          name="phoneNumber"
                          id="phoneNumber"
                          value={values.phoneNumber}
                          placeholder="Enter Phone Number"
                          invalid={
                            errors.phoneNumber && touched.phoneNumber
                              ? true
                              : false
                          }
                          onChange={handleChange}
                        />
                        <FormFeedback>
                          {errors.phoneNumber && touched.phoneNumber
                            ? errors.phoneNumber
                            : ""}
                        </FormFeedback>
                      </InputGroup>
                    </FormGroup>
                    <Row className="item-center">
                      <Col className="item-center">
                        <center>
                          <Button type="submit" color="primary">
                            {loading && <CustomButtonLoader />}
                            Submit
                          </Button>
                        </center>
                      </Col>
                    </Row>
                    <Link to={`/customer/${agencyUrl}`}>
                      <div className="urs-signup">
                        <a
                          href={`/customer/${agencyUrl}`}
                          rel="noopener noreferrer"
                        >
                          {" "}
                          Already have an account? Sign In
                        </a>
                      </div>
                    </Link>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </Fragment>
  );
}
